import { render, staticRenderFns } from "./choosePrize.vue?vue&type=template&id=648fd39b&scoped=true"
import script from "./choosePrize.vue?vue&type=script&lang=ts"
export * from "./choosePrize.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648fd39b",
  null
  
)

export default component.exports